import { ViolationReasonBreakdown } from "@CommonApi/violation/merchflow/_merchflowId_";

const TOP_CATEGORIES = 3;

// The breakdown is keyed by store, then reason category, then count.
export const aggregateReasonTotals = (
  breakdown: ViolationReasonBreakdown,
): Record<string, number> => {
  const totals: Record<string, number> = {};
  for (const counts of Object.values(breakdown)) {
    for (const [category, count] of Object.entries(counts)) {
      totals[category] = (totals[category] ?? 0) + count;
    }
  }
  return totals;
};

export const buildReasonSummary = (breakdown: ViolationReasonBreakdown): string => {
  const sortedTotals = Object.entries(aggregateReasonTotals(breakdown)).sort(
    ([categoryA, countA], [categoryB, countB]) =>
      countB - countA || categoryA.localeCompare(categoryB),
  );

  if (sortedTotals.length === 0) {
    return "—";
  }

  const summary = sortedTotals
    .slice(0, TOP_CATEGORIES)
    .map(([category, count]) => `${category}: ${count}`)
    .join(", ");
  const hiddenCategoryCount = sortedTotals.length - TOP_CATEGORIES;

  return hiddenCategoryCount > 0 ? `${summary}, +${hiddenCategoryCount} more` : summary;
};
